module.exports = __webpack_public_path__ + "static/img/4areaB_14.1ec73b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_14.png
// module id = 1187
// module chunks = 1